// 랜딩 문구 한 벌(홈페이지 시안 3) — 그림 속 예시 값은 화면 그림(apps/web mockups.tsx)이 갖는다.

export const LANDING_TAGLINE = "인테리어 시공사용 현장관리";

export const HERO = {
  eyebrow: "인테리어 시공사를 위한 현장 관리",
  // 두 줄 — 둘째 줄은 강조색.
  title: ["흩어진 현장을", "한곳에"],
  body: "문의부터 잔금까지, 몇 달짜리 공사를 한곳에서 챙겨요.",
  demo: "데모 보기",
  checks: ["기간 제한 없는 무료 요금제 · 현장·직원 수 제한 없음", "고객은 앱 설치 없이 문자 링크로 확인"],
} as const;

// 히어로 밑 띠 — strong 은 굵게, rest 는 바로 이어 붙는다.
export const HERO_FACTS = [
  { strong: "엑셀 견적 그대로", rest: " 올리면 견적으로" },
  { strong: "표준계약서", rest: " 기본 제공·우리 문구로" },
  { strong: "매일 사진·일지", rest: " → 고객 알림" },
  { strong: "언제든 ZIP", rest: "으로 전부 내려받기" },
] as const;

export type PainScene = "laptop" | "call" | "photos" | "lock";

// 흩어진 네 곳(왼쪽 둘·오른쪽 둘)이 가운데 현장 하나로 모인다.
export const PAIN = {
  title: "지금 현장은 이렇게 흩어져 있어요",
  items: [
    { scene: "laptop", what: "견적은", where: "디자이너 노트북에" },
    { scene: "call", what: "추가금 약속은", where: "지난주 통화 속에" },
    { scene: "photos", what: "현장 사진은", where: "반장님 휴대폰에" },
    { scene: "lock", what: "고객 걱정은", where: "밤 10시 전화로" },
  ] as const satisfies readonly { scene: PainScene; what: string; where: string }[],
  hub: {
    label: "빌드파이 · 현장 하나",
    site: "성수 28평 전체 리모델링",
    checks: ["견적 v3 최종 · 이전 판도 남음", "현장 사진 날짜별로 이 현장에", "추가금 +120만 원 고객 확인", "오늘 일지 → 고객에게 알림"],
    outro: "이 모든 걸 하나의 프로젝트로",
  },
} as const;

// 첫 화면 네 단계 — 칸 머리 이름과 폰에서만 보이는 한 줄 설명.
export const STEPS = [
  { label: "문의", cap: "· 들어오면 현장이 생겨요" },
  { label: "견적", cap: "· 고칠 때마다 이력이 남아요" },
  { label: "계약", cap: "· 확인받은 견적 그대로" },
  { label: "공사", cap: "· 매일 사진·일지가 고객에게" },
] as const;

export type FlowIcon = "browser" | "link" | "qr" | "history" | "template" | "won" | "file" | "check" | "smartphone";

export interface FlowRow {
  eyebrow: string;
  title: readonly string[];
  bullets: readonly { icon: FlowIcon; title: string; desc: string }[];
}

export const FLOW = {
  eyebrow: "문의부터 계약까지",
  title: ["문의 받고, 견적 보내고,", "계약서까지 한곳에서"],
  rows: [
    {
      eyebrow: "01 문의",
      title: ["홈페이지가 있든 없든", "문의는 한곳으로 모여요"],
      bullets: [
        { icon: "browser", title: "홈페이지 문의 연결 API 제공", desc: "쓰시던 홈페이지에 붙이면 거기서 남긴 문의가 바로 들어와요." },
        { icon: "link", title: "문의 페이지 제공", desc: "문의 받을 페이지 주소를 드려요. 블로그·인스타 프로필에 걸어 두면 돼요." },
        { icon: "qr", title: "공사 안내문 QR", desc: "현장 앞 공사 안내문에 QR이 들어가요. 지나던 이웃도 바로 문의해요." },
      ],
    },
    {
      eyebrow: "02 견적",
      title: ["고친 이력은 다 남고,", "다음 견적은 더 빨라져요"],
      bullets: [
        { icon: "history", title: "수정 이력 관리", desc: "가견적부터 3차까지 고칠 때마다 이전 견적이 남아요. 고객은 바뀐 부분만 보고 확인해요." },
        { icon: "template", title: "자주 쓰는 견적은 템플릿으로", desc: "30평대 전체 리모델링처럼 자주 내는 구성은 저장해 두고 불러와 시작해요." },
        { icon: "won", title: "지난 단가를 먼저 채워 줘요", desc: "같은 항목은 지난 현장에서 쓴 단가가 먼저 들어가요. 하나하나 찾아보지 않아도 돼요." },
      ],
    },
    {
      eyebrow: "03 계약",
      title: ["표준계약서로 시작해", "서명까지 휴대폰으로"],
      bullets: [
        { icon: "file", title: "표준계약서를 우리 회사 문구로", desc: "공정위·국토부 표준계약서를 기본으로 드려요. 조항을 고쳐 저장하면 다음 계약부터 그 양식으로 나가요." },
        { icon: "check", title: "금액·지급 일정은 견적에서", desc: "확인받은 견적 금액과 계약금·중도금·잔금이 알아서 채워져요." },
        { icon: "smartphone", title: "고객은 문자로 확인하고 서명", desc: "앱 설치나 가입 없이 문자 링크로 서명해요. 서명한 계약서는 고칠 수 없게 보관돼요." },
      ],
    },
  ] as const satisfies readonly FlowRow[],
} as const;

export const BOARD = {
  title: ["진행 중인 현장 전부,", "한 화면에서 관리해요"],
  body: "단계별로 모여 있어서 어느 현장이 어디까지 왔는지 바로 보여요.",
} as const;

export const AFTER = {
  eyebrow: "공사 중부터 공사 끝까지",
  title: ["계약하고 나서도", "흩어지지 않아요"],
  cards: [
    { label: "매일", text: ["오늘 사진·일지가 가서", "고객이 먼저 묻지 않아요"] },
    { label: "추가 공사", text: ["고객이 확인한 추가금이", "잔금에 바로 붙어요"] },
    { label: "공사 끝", text: ["남은 사진·일지가", "AS도, 다음 손님도 챙겨요"] },
  ],
} as const;

export const PRICING = {
  title: "요금제",
  body: "기능은 모두 같고, 사진 저장과 알림톡 양만 달라요.",
  note: "한도에 가까워지면 미리 알려 드리고, 넘어도 막지 않아요.",
} as const;

export const FAQ_TITLE = "자주 묻는 질문";

export const FAQ = [
  {
    q: "지금 쓰는 엑셀 견적서는 어떻게 하나요?",
    a: "쓰시던 견적 엑셀 파일을 그대로 올리면 항목과 금액을 읽어 견적으로 옮겨 드려요. 처음부터 다시 입력하지 않아도 되고, 옮긴 견적은 템플릿으로 저장해 다음 현장에서 다시 쓸 수 있어요.",
  },
  {
    q: "고객도 가입하거나 앱을 깔아야 하나요?",
    a: "아니요. 견적서·계약서·공사 소식은 고객 휴대폰으로 문자 링크가 가요. 링크를 누르고 전화번호 뒤 4자리만 넣으면 바로 볼 수 있어서, 연세 있는 고객도 어렵지 않게 확인해요.",
  },
  {
    q: "우리 회사 계약서 문구를 그대로 쓸 수 있나요?",
    a: "네. 공정위·국토부 표준계약서를 기본으로 드리고, 조항을 우리 회사 문구로 고쳐 저장해 두면 다음 계약부터 그 양식으로 나가요. 금액과 지급 일정은 확인받은 견적에서 알아서 채워져요.",
  },
  {
    q: "무료로 언제까지 쓸 수 있나요?",
    a: "무료 요금제는 기간 제한 없이 계속 쓰실 수 있어요. 기능도 전부 열려 있고 현장·고객·직원 수 제한도 없어요. 사진 저장(1GB)과 알림톡(월 30건)만 한도가 있고, 가까워지면 미리 알려 드려요.",
  },
  {
    q: "쓰다가 그만두면 자료는 어떻게 되나요?",
    a: "견적·계약·현장일지와 사진 원본까지 언제든 ZIP 파일 하나로 내려받을 수 있어요. 그만두셔도 그동안 쌓은 자료는 그대로 가져가실 수 있어요.",
  },
] as const;

export const CLOSING = {
  title: ["다음 현장부터", "한곳에 모아 보세요"],
  body: "카드 등록 없이 무료로 시작할 수 있어요.",
  contact: "도입 문의",
} as const;
